export default {"src":"/_next/static/media/icon_share.27cbe871.svg","height":22,"width":22,"blurWidth":0,"blurHeight":0};